<script setup>
const sections = [
  {
    texts: [
      'Datenschutz liegt uns RAUMPIONIEREN sehr am Herzen. Das heisst, wir bekennen uns ausdrücklich zum Schutz und zur gesetzeskonformen Erhebung, Verarbeitung und Nutzung der Userdaten. Wichtig: Mit dem Zugriff auf die Webseite raumpioniere.ch erklären Sie Ihr Einverständnis mit den hier publizierten Datenschutzbestimmungen. Falls Sie mit den nachfolgenden Bestimmungen nicht einverstanden sein sollten, verzichten Sie bitte auf den Zugriff auf weitere Seiten unserer Webseite. Registrierte User willigen zudem in die Erhebung, Verarbeitung und Nutzung ihrer personenbezogenen Daten ein.'
    ]
  },
  {
    title: 'Grundsatz & Zweck',
    texts: [
      'Wir RAUMPIONIERE bekennen uns ausdrücklich zum Schutz und zur gesetzeskonformen Erhebung, Verarbeitung und Nutzung der Userdaten. Die folgenden Bestimmungen erläutern dabei die Art und Weise sowie den Zweck, zu welchem wir Daten sammeln, verarbeiten und nutzen.'
    ]
  },
  {
    title: 'Rechtsgrundlagen',
    texts: [
      'Der Geschäftssitz von uns RAUMPIONIEREN liegt in der Schweiz. Somit unterliegen wir im Umgang mit personenbezogenen Daten, insbesondere von in der Schweiz wohnhaften Personen, primär dem Bundesgesetz über den Datenschutz (DSG). Ausserdem dient die Datenschutz-Grundverordnung (DSGVO) der EU als Rechtsgrundlage für den Umgang mit personenbezogenen Daten von Bürgern der Europäischen Union.'
    ]
  },
  {
    title: 'Webanalyse',
    texts: [
      'Wir RAUMPIONIERE verwenden folgende Tracking-Technologien von Drittanbietern zur Verbesserung unserer Webseite:'
    ]
  },
  {
    title: 'Cookies',
    texts: [
      'Cookies sind kleine Dateien, die auf Ihrem Datenträger gespeichert werden und die bestimmte Einstellungen und Daten zum Austausch mit unserem System über Ihren Browser speichern. Sie ermöglichen eine erleichterte Nutzung unserer raumpioniere.ch-Webseite, indem beispielsweise bestimmte Eingaben nicht bei jedem einzelnen Besuch wiederholt werden müssen. Die Daten speichern wir ausschliesslich aus einem Grund: um unser Angebot Ihren Wünschen entsprechend bestmöglich anpassen zu können und unsere Webseite für Sie als User so einfach und komfortabel wie möglich zu gestalten.',
      'Die Cookies können im Browser jederzeit ganz oder teilweise deaktiviert werden. Bei deaktivierten Cookies stehen dem Kunden allenfalls aber nicht mehr alle Funktionen zur Verfügung.'
    ]
  },
  {
    title: 'Google Analytics',
    texts: [
      'Wir RAUMPIONIERE nutzen auf unserer Webseite und auf der Plattform «Google Analytics» einen Webanalysedienst der Google Inc. mit Sitz in den USA.',
      'Google Analytics verwendet ebenfalls die bereits beschriebenen Cookies. Die dadurch erzeugten Informationen über die Benutzung der Webseite oder der Plattform (Browser-Typ/-Version, verwendetes Betriebssystem, Referrer-URL (zuvor besuchte Webseite), anonymisierte IP-Adresse und Uhrzeit der Serveranfrage) werden an Server von Google übertragen und dort gespeichert. Aufgrund dieser gespeicherten Daten können keine Rückschlüsse auf die Person gemacht werden. Gegebenenfalls werden diese Informationen an Dritte übertragen, wenn diese die Daten im Auftrag von Google verarbeiten.',
      'Unter keinen Umständen wird die IP-Adresse mit anderen den Nutzer betreffenden Daten in Verbindung gebracht.',
      'Wir RAUMPIONIERE verwenden für Google Analytics einen Zusatz, mit dem die IP-Adresse des Internetanschlusses von Google gekürzt und anonymisiert wird.',
      'Zusätzlich nutzen wir RAUMPIONIERE Remarketing-Listen von Google Analytics. Mit Remarketing-Listen können Besucher der Webseite oder der Plattform durch zielgerichtete Werbung auf den Seiten des Google-Partnernetzwerks und des Google-Suchnetzwerks erneut angesprochen werden. Die Einblendung der Werbung erfolgt ebenfalls durch Cookies.',
      'Weiter werden durch die erhobenen Daten unter Verwendung von Pseudonymen Nutzungsprofile erstellt. Diese dienen der Analyse des Besucherverhaltens und werden zur Verbesserung und bedarfsgerechten Gestaltung des Angebots ausgewertet. Die pseudonymisierten Nutzungsprofile werden nicht mit personenbezogenen Daten des Trägers zusammengeführt.',
      'Der Erfassung durch Google Analytics kann der Kunde jederzeit widersprechen. Dazu muss ein Browser-Add-On unter dem Link https://tools.google.com/dlpage/gaoptout?hl=de heruntergeladen und installiert werden. Dieses Browser-Add-On teilt Google Analytics über JavaScript mit, dass keine Daten und Informationen zu den Besuchen von Internetseiten an Google Analytics übermittelt werden dürfen. Sofern das Browser-Add-On einmal deinstalliert oder deaktiviert wird, besteht die Möglichkeit der Neuinstallation oder der erneuten Aktivierung.',
      'Weitere Angaben zum Datenschutz bei Google können unter folgendem Link abgerufen werden: https://www.google.com/intl/de_DE/analytics/learn/privacy.html'
    ]
  },
  {
    title: 'HubSpot',
    texts: [
      'Auf unserer Website verwenden wir RAUMPIONIERE HubSpot für verschiedene Zwecke.',
      'HubSpot wird von HubSpot, Inc. mit Sitz in 25 First Street, 2nd Floor, Cambridge, MA 02141 USA bereitgestellt.',
      'HubSpot ist eine integrierte Softwarelösung, die wir nutzen, um verschiedene Aspekte unseres Online-Marketings abzudecken. Dazu gehören u.a.: E-Mail-Marketing, Social Media Publishing & Reporting, Reporting, Kontaktmanagement (z.B. Nutzersegmentierung & CRM), Landing Pages und Kontaktformulare. Weitere Informationen finden Sie in der Datenschutzrichtlinie von HubSpot: https://legal.hubspot.com/privacy-policy'
    ]
  },
  {
    title: 'LinkedIn',
    texts: [
      'Unsere Seite nutzt auch Funktionen des LinkedIn-Netzwerks.',
      'Der Anbieter ist die LinkedIn Corporation, 2029 Stierlin Court, Mountain View, CA 94043, USA. Bei jedem Zugriff auf eine unserer Seiten, die LinkedIn-Funktionen enthält, wird eine Verbindung zu Servern von LinkedIn hergestellt. LinkedIn erhält dadurch die Information, dass Sie mit Ihrer IP-Adresse unsere Seite besucht haben. Wenn Sie den «Recommend»-Button von LinkedIn anklicken und in Ihrem Benutzerkonto bei LinkedIn eingeloggt sind, ist es LinkedIn möglich, Ihren Besuch auf unserer Seite Ihnen und Ihrem Benutzerkonto zuzuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch LinkedIn erhalten. Weitere Informationen finden Sie in den Datenschutzbestimmungen von LinkedIn unter: https://www.linkedin.com/legal/privacy-policy'
    ]
  },
  {
    title: 'Erfassung allgemeiner Informationen',
    texts: [
      'Bei jedem Zugriff auf die Seiten unserer Webseite werden durch den jeweiligen Internetbrowser Nutzungsdaten übermittelt und in Protokolldateien, Server-Logfiles genannt, gespeichert. Die dabei gespeicherten Datensätze enthalten folgende Informationen:',
      'Datum und Uhrzeit des Abrufs, Name der aufgerufenen Seite, IP-Adresse, Referral-URL, die übertragene Datenmenge sowie Produkt und Versions-Informationen des verwendeten Browsers, sowie das Surfverhalten auf unserer RAUMPIONIERE-Webseite.',
      'Die IP-Adressen der User werden nach Beendigung der Nutzung gelöscht oder anonymisiert, so dass Einzelangaben über persönliche oder sachliche Verhältnisse nicht mehr, oder nur mit einem unverhältnismässig grossen Aufwand an Zeit, Kosten und Arbeitskraft einer bestimmten oder bestimmbaren natürlichen Person zugeordnet werden können. Diese Logfile-Informationen werden von uns in anonymisierter Form ausgewertet, um die Benutzerfreundlichkeit unserer Webseite und die Dienste von uns RAUMPIONIEREN zu verbessern, sowie allfällige Fehler zu identifizieren und zu beheben.'
    ]
  },
  {
    title: 'Personenbezogene Daten',
    texts: [
      'Personenbezogene Daten sind Angaben über sachliche oder persönliche Verhältnisse einer bestimmten oder bestimmbaren natürlichen Person. Darunter fallen beispielsweise Name, Telefonnummer, Anschrift, sowie sämtliche anderen Informationen, die User bei der Registrierung auf der raumpioniere.ch-Webseite anlegen.',
      'Personenbezogene Daten werden für die Nutzung unserer Dienstleistungen als registrierter User erhoben, gespeichert und verarbeitet. Die Daten werden von uns gelöscht, sobald sie für den Zweck, für den sie erhoben wurden, nicht mehr benutzt werden oder Sie als User einen Löschungsanspruch geltend machen.'
    ]
  },
  {
    title: 'Drittdienstleister',
    texts: [
      'Wir RAUMPIONIERE übermitteln Ihre personenbezogenen Daten nur an Drittdienstleister, die sie für uns verarbeiten, um mit ihnen spezifische RAUMPIONIER-Dienstleistungen zu ermöglichen.',
      'Bei der Nutzung von dritten Dienstleistern treffen wir aber immer Vereinbarungen, die entsprechende technische und organisatorische Massnahmen zum Schutz Ihrer personenbezogenen Daten vorsehen.'
    ]
  },
  {
    title: 'Sichere Datenübertragung',
    texts: [
      'Wir RAUMPIONIERE setzen auf technische und organisatorische Massnahmen, um personenbezogene Daten vor unerlaubtem Zugriff, versehentliche oder beabsichtigte Manipulation, Verlust und Zerstörung zu schützen.'
    ]
  },
  {
    title: 'Auskunftsrecht',
    texts: [
      'User haben selbstverständlich das Recht, Auskunft über die gespeicherten Daten zu verlangen sowie gegebenenfalls die Berichtigung, Sperrung oder Löschung von Daten-/Adressauswertungen zu bewirken.',
      'Bitte richten Sie Ihre Anfrage mit einer eindeutigen Identifizierung (Bild eines Ausweises) Ihrer Person elektronisch an:',
      'info@raumpioniere.ch. Und postalisch: RAUMPIONIERE AG, Bahnhofstrasse 6, 9000 St. Gallen.',
      'Bitte haben Sie Verständnis dafür, dass wir keine telefonischen Auskünfte geben oder Löschbegehren entgegennehmen. Besten Dank.'
    ]
  }
]
</script>

<template lang='pug'>
.full-width
  .routerPageSize
    .privacyContainer
      .header
        div Unsere
        div Datenschutzbestimmungen.
      .sectionsContainer
        .section(v-for="(section, index) in sections" :key="index")
          .sectionTitle.sectionText(v-if="section.title") {{ section.title }}
          .column(v-if="section.texts")
            .sectionText(v-for="text in section.texts" :key="text") {{ text }}
</template>

<style lang='sass'>
.privacyContainer
  padding: 20px 0 60px 0
  .header
    @media screen and (min-width: 1024px)
      margin: 40px 0
      font-weight: 800
      font-size: 50px
      line-height: 130%
      color: #2F3849
    @media screen and (max-width: 1023px)
      font-weight: 700
      color: #2F3849
      font-size: 20px
      line-height: 130%
  .sectionsContainer
    margin: 20px 0
    .sectionTitle
      @media screen and (min-width: 1024px)
        padding: 40px 0 20px 0
      @media screen and (max-width: 1023px)
        padding: 20px 0 10px 0
    .sectionText
      @media screen and (min-width: 1024px)
        font-weight: 700
        font-size: 16px
        line-height: 130%
        color: #626C85
      @media screen and (max-width: 1023px)
        font-weight: 500
        font-size: 12px
        line-height: 130%
        color: #626C85
</style>
